// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import React from 'react';
import { GLYPH_STROKE } from './glyph';
import type { SymbolGlyphProps } from './glyph';
import { RotatingMachine } from './RotatingMachine';

/**
 * Fan — the rotating-machine circle with two blades on a hub.
 *
 * CRAHs, AHUs, rooftop units and supply fans draw as this. There is no IEC
 * one-line fan symbol; the blades are the HMI convention (Ignition's fan and
 * blower symbols, ISA 5.1's fan) reduced to what survives at 18 px. Flagged
 * medium confidence in the mapping doc for exactly that reason.
 */
export const FanSymbol = ({ size = 18, run, leads }: SymbolGlyphProps) => (
  <RotatingMachine size={size} run={run} leads={leads}>
    <path
      className="sld-glyph__mark"
      d="M12 12 C 9 7.5, 15.5 6, 14.5 10.5 Z M12 12 C 15 16.5, 8.5 18, 9.5 13.5 Z"
      stroke="currentColor"
      strokeWidth={GLYPH_STROKE - 0.4}
      strokeLinejoin="round"
    />
    <circle className="sld-glyph__mark" cx="12" cy="12" r="1.3" fill="currentColor" />
  </RotatingMachine>
);
